import { Box, Skeleton } from '@mui/material';
import { VerificationSummary } from 'apps/wrapper/src/services/insurance/types/verification-summary';
import { FC, useState } from 'react';
import { useEventBus } from '../../../../hooks/use-event-bus';
import { CarrierName, StatusText, StatusWrapper } from '../../shared/styles';

export interface ApptRequestIvStatusButtonProps {
  text: string;
  icon: React.ReactNode;
  locationId?: number;
  appointmentRequestId?: number;
  ivSummary?: VerificationSummary;
}

export const ApptRequestIvStatusButton: FC<ApptRequestIvStatusButtonProps> = (props): React.ReactElement => {
  const { text, locationId, appointmentRequestId, ivSummary, icon } = props;
  const { publish } = useEventBus();
  const [isLoading, setIsLoading] = useState(false);

  const handlePatientFlowClick = () => {
    if (!locationId || !appointmentRequestId) return;

    setIsLoading(true);

    publish({
      messageType: 'ivShowApptRequestVerificationDialog',
      data: {
        locationId,
        apptRequestId: appointmentRequestId
      }
    });

    setTimeout(() => setIsLoading(false), 1000);
  };

  return (
    <>
      <StatusWrapper className="status-wrapper">
        {icon}
        <Box sx={{ display: 'flex', flexDirection: 'column', marginLeft: '8px' }}>
          {ivSummary?.idPayer && <CarrierName className="carrier-name">{ivSummary.idPayer}</CarrierName>}
          {isLoading && <Skeleton height={20} width={120} />}
          {!isLoading && <StatusText onClick={handlePatientFlowClick}>{text || 'Unknown'}</StatusText>}
        </Box>
      </StatusWrapper>
    </>
  );
};
